import { HTMLAttributes } from 'react';

export const enum FormItemType {
  text = 'text',
  input = 'input',
  choice = 'choices',
  multi_choice = 'choices',
  checkbox = 'checkbox',
  button = 'button',
  dynamic_spacer = 'dynamic_spacer',
  image = 'static_image',
  video = 'video',
}

type Term = {
  anchor: string;
  content: string;
};

export interface ContactFormItem {
  ref_id: string;
  item_type: FormItemType;
  required: boolean;
  value: string | string[] | boolean;
  errors?: string[];
  label: string;
  selector_type: 'single' | 'multi';
}

export type InputTypeHint =
  | 'text'
  | 'number'
  | 'email'
  | 'phone'
  | 'zip-code'
  | 'email-or-phone'
  | 'npi-number'
  | 'multi_line_text';

type T = HTMLAttributes<HTMLInputElement>;
type K = keyof T & { type: string };

export interface FormItemInput extends ContactFormItem {
  item_type: FormItemType.input;
  input_type_hint: InputTypeHint;
  placeholder: string;
  tooltips?: Term[];
}

export interface FormItemSingleChoice extends ContactFormItem {
  item_type: FormItemType.choice;
  choices_additional_data: string;
  choices: string[];
}

export interface FormItemCheckbox extends ContactFormItem {
  item_type: FormItemType.checkbox;
  event_name: string;
  text: string;
  tooltips?: Term[];
}

export interface FormItemText extends ContactFormItem {
  item_type: FormItemType.text;
  label: string;
  placeholder: string;
  tooltips?: Term[];
}

export interface FormItemButton extends ContactFormItem {
  item_type: FormItemType.button;
  button_text: string;
  button_style: 'primary' | 'secondary' | 'text';
}

export interface FormItemImage extends ContactFormItem {
  item_type: FormItemType.image;
  url: string;
  link_url?: string;
  alignment?: 'left' | 'center' | 'right';
  scale?: number;
  alt_text?: string;
}

export interface FormItemVideo extends ContactFormItem {
  item_type: FormItemType.video;
  url: string;
  placeholder_image_url?: string;
  video_name?: string;
  title?: string;
}

export type InputAttributes = Record<K, T>;
